import { getLandingPageStaticProps } from '@/graphql/WebLandingPage'

import { LandingPage } from '@/components/blocks/LandingPage/LandingPage'

export const getStaticProps = getLandingPageStaticProps('menoscaleLandingPage')

export default LandingPage
